import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
      <div className="w-full">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1.5 h-7 rounded-full bg-accent-500" />
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">热门排行</h2>
          </div>
          <span className="text-xs text-foreground-500 hidden sm:block">TOP 7 · 实时热度榜单</span>
        </div>

        <div className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden">
          {rankingData.map((item, index) => (
            <div
              key={index}
              className={`flex items-center gap-4 px-4 md:px-6 py-4 transition-colors hover:bg-background-100 cursor-pointer ${
                index !== rankingData.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div
                className={`w-8 h-8 rounded-lg flex items-center justify-center text-xs font-bold shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-primary-400 text-background-50'
                    : item.rank === 3
                    ? 'bg-primary-300 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm font-semibold text-foreground-800 truncate">
                    {item.title}
                  </h3>
                  <span className="inline-block px-2 py-0.5 text-[10px] font-medium rounded bg-accent-100 text-accent-700 shrink-0">
                    {item.tag}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-3 shrink-0">
                <span className="text-xs text-foreground-500 whitespace-nowrap">
                  {item.heat}热度
                </span>
                <div className={`w-5 h-5 flex items-center justify-center ${
                  item.trend === 'up' ? 'text-primary-500' : item.trend === 'down' ? 'text-foreground-400' : 'text-foreground-400'
                }`}>
                  {item.trend === 'up' && <i className="ri-arrow-up-line" />}
                  {item.trend === 'down' && <i className="ri-arrow-down-line" />}
                  {item.trend === 'same' && <i className="ri-subtract-line" />}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}